var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 .102 19.25 6.2v12.55H.75V6.2zM2.25 7.008V17.25h15.5V7.008L10 1.898z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.469 10.585-3.497 2.798-2-1.8-2.503 2.002-.938-1.17L9.03 9.615l2 1.8 2.502-2.002z",
    clipRule: "evenodd"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAwLjEwMTU2MkwxOS4yNSA2LjIwMDQ2VjE4Ljc0OTlIMC43NVY2LjIwMDQ2TDEwIDAuMTAxNTYyWk0yLjI1IDcuMDA4MTZWMTcuMjQ5OUgxNy43NVY3LjAwODE2TDEwIDEuODk4MjdMMi4yNSA3LjAwODE2WiIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC40Njg1IDEwLjU4NTRMMTAuOTcxNSAxMy4zODNMOC45NzE0NSAxMS41ODNMNi40Njg1NCAxMy41ODU0TDUuNTMxNDkgMTIuNDE0MUw5LjAyODU4IDkuNjE2NEwxMS4wMjg2IDExLjQxNjRMMTMuNTMxNSA5LjQxNDA2TDE0LjQ2ODUgMTAuNTg1NFoiIC8+Cjwvc3ZnPgo=";